var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { ComponentClass } from 'conversional-theme';
import TextBox from './QuestionTextBox';
import { renderClasses } from './ConsultantBox.styles';
import ImageWrapper from '../../imageWrapper';
import classNames from 'classnames';
import createComponentsFromObject from '../../../utilities/components/createComponentsFromObject';
import { JourneysSelectors, useAppSelector } from 'conversional-journey';
var AVATAR_POSITIONS = {
    TOP: 'top',
};
// Left-hand avatar image and description (if space permits)
var Avatar = function (_a) {
    var _b, _c;
    var src = _a.src, name = _a.name, forcedImageWidth = _a.forcedImageWidth, role = _a.role, position = _a.position, _d = _a.styles, styles = _d === void 0 ? {} : _d, mobileWidth = _a.mobileWidth, _e = _a.imageStyles, imageStyles = _e === void 0 ? {} : _e;
    var theme = useAppSelector(JourneysSelectors.selectTheme);
    var classes = renderClasses(theme);
    return (_jsxs("div", { role: 'conversional-question-avatar', className: classNames((_b = {},
            _b[classes.avatar] = true,
            _b[classes.avatarTop] = position === AVATAR_POSITIONS.TOP,
            _b[classes.avatarMobile] = mobileWidth,
            _b[ComponentClass(styles)] = true,
            _b)), children: [_jsx(ImageWrapper, { getWidth: function () { return forcedImageWidth; }, src: src, alt: name, title: name, className: classNames((_c = {},
                    _c[classes.img] = true,
                    _c[classes.avatarTopImg] = position === AVATAR_POSITIONS.TOP,
                    _c[ComponentClass(imageStyles)] = true,
                    _c)) }), _jsxs("div", { className: classes.belowAvatar, children: [_jsx("p", { className: classes.name, children: name }), _jsx("p", { className: classes.role, children: role })] })] }));
};
// Chat-like headline above avatar text
var AvatarDescription = function (_a) {
    var name = _a.name, role = _a.role;
    var theme = useAppSelector(JourneysSelectors.selectTheme);
    var classes = renderClasses(theme);
    return (_jsxs("p", { className: classes.description, children: [name, role && ', ', _jsx("span", { className: classes.role, children: role })] }));
};
// Box component with avatar and speech bubble
var ConsultantBox = function (_a) {
    var _b, _c, _d;
    var containerClassName = _a.containerClassName, beforeContentChildren = _a.beforeContentChildren, header = _a.header, main = _a.main, footer = _a.footer, avatar = _a.avatar, children = _a.children, styles = _a.styles, _e = _a.headerStyles, headerStyles = _e === void 0 ? {} : _e, _f = _a.mainStyles, mainStyles = _f === void 0 ? {} : _f, _g = _a.containerStyles, containerStyles = _g === void 0 ? {} : _g, _h = _a.showCaret, showCaret = _h === void 0 ? true : _h, _j = _a.showAvatarDescription, showAvatarDescription = _j === void 0 ? true : _j;
    var theme = useAppSelector(JourneysSelectors.selectTheme);
    var classes = renderClasses(theme);
    return (_jsxs("div", { className: classNames(classes.container, (_b = {},
            _b[classes.topAvatarContainer] = avatar.position === AVATAR_POSITIONS.TOP,
            _b)), children: [_jsx(Avatar, __assign({}, avatar)), _jsxs("div", { className: classNames(classes.textBoxContainer, ComponentClass(containerStyles), containerClassName, (_c = {},
                    _c[classes.textBoxContainerTop] = avatar.position === AVATAR_POSITIONS.TOP,
                    _c)), children: [showCaret && (_jsx("div", { role: 'conversional-question-caret', className: classNames(classes.caret, ComponentClass(styles), (_d = {},
                            _d[classes.caretTop] = avatar.position === AVATAR_POSITIONS.TOP,
                            _d)) })), _jsx(TextBox, { header: header, main: main, footer: footer, styles: styles, headerStyles: headerStyles, mainStyles: mainStyles, consultant: true, beforeContent: _jsxs(_Fragment, { children: [showAvatarDescription && _jsx(AvatarDescription, __assign({}, avatar)), createComponentsFromObject(beforeContentChildren)] }), children: children })] })] }));
};
export default ConsultantBox;
